import { useState } from "react";
import { FeriasProporcionais } from "./components/FeriasProporcionais";
import { ProporcionalResponse } from "./components/ProporcionaisResponse";
import { ResponseProporcional } from "./Proporcional";

export default function SalarioFeriasProporcional() {
    const [results, setResults] = useState<ResponseProporcional | null>(null);

    return (
        <>

            <FeriasProporcionais setResults={setResults} />
            {results && <ProporcionalResponse results={results} />}

        </>
    );
}

